export default __webpack_public_path__ + "static/media/Panchami1.04b46ad6.png";